import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Box, Grid } from '@mui/material'
import DealItem from '@components/DealItem'
import { getDealList } from '@hooks/contract'
import { useWallet } from '@utils/walletHelper'
import ClockLoader from '@components/Loaders/Clock'
import Layout from "../Layout"

const DealList = () => {
  const { connecting, walletAddress } = useWallet()
  const [dealList, setDealList] = useState(null)
  const [loader, setLoader] = useState(false)

  // useEffect(() => {
  //   let _interval = setInterval(() => {
  //     initialHandler()
  //   }, 10000)

  //   return () => {
  //     clearInterval(_interval)
  //   }
  // })

  useEffect(() => {
    let isMounted = true
    const fetchData = async () => {
      if (!connecting) {
        setLoader(true)
        const result = await getDealList(walletAddress, "all_deals")

        if (isMounted) {
          setDealList(result)
          setLoader(false)
        }
      }
    }
    fetchData()

    return () => { isMounted = false }
  }, [walletAddress, connecting, setDealList, setLoader])

  const initialHandler = async () => {
    setDealList(await getDealList(walletAddress, "all_deals"))
  }

  return (
    <Layout>
      {
        dealList !== null && dealList.length > 0 ? (
          <Grid container spacing={2} sx={{ pt: 2 }}>
            {
              dealList.slice(0).reverse().map((data, index) => {
                return (
                  <Grid
                    key={index}
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={4}
                    xl={3}
                  >
                    <Link
                      to={`/deal/${data.id}`}
                      className="no_underline text-white"
                    >
                      <DealItem data={data} />
                    </Link>
                  </Grid>
                )
              })
            }
          </Grid>
        )
          : !loader && (
            <Box
              sx={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", paddingTop: "15vh" }}
            >
              <Box>There is no data</Box>
            </Box>
          )
        /*<Box
            sx={{display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", paddingTop: "15vh"}}
        >
            <Typography className="font-24 font-bold">
                Bonuses for Bold Investors
            </Typography>
            <Typography className="font-bold" sx={{pt: 1, pb: 2}}>
                Learn more at <Link href="https://www.presail.club" underline='none'>www.presail.club</Link>
            </Typography>
            <Button 
                className="btn-info btn-lg font-bold"
                onClick={connectHandler}
            >
                Connect Wallet
            </Button>
        </Box>*/
      }
      {loader && <ClockLoader />}
    </Layout>
  )
}

export default DealList;